import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'pm-emoji',
  imports: [CommonModule],
  templateUrl: './pm-emoji.component.html',
  styleUrl: './pm-emoji.component.scss',
})
export class PmEmojiComponent {
  @Input({ required: true }) emoji!: any;
  @Input() size: number = 32;
}
